/* eslint-disable no-useless-escape */
// export const address = /^([A-Za-zöäüß])+ {0,1}([A-Za-zöäüß])* ([0-9])+[A-Za-z]*$/;
export const austrianZip = /^\d+$/;
export const austrianPhone = /^\+[1-9]{1}[0-9]{3,14}$/;
export const email = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
